import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSiteStatusStore = defineStore('siteStatus', () => {
    type SiteStatus = 'blocked' | 'maintenance';
    const isBlocked = ref<boolean>(false);
    const isMaintenance = ref<boolean>(false);
    function toSetSiteStatus(status: SiteStatus, value: boolean): void {
        if (status === 'blocked') {
            isBlocked.value = value;
        } else if (status === 'maintenance') {
            isMaintenance.value = value;
        }
    }
    return { isBlocked, isMaintenance, toSetSiteStatus };
});
